import * as constants from '../StoreConstants/KeyFeatureConstants';

export const KeyFeatureStore = {
    state: {
        isKeyFeturesExits: false,
        isSpecialsloaded: ''
    },
    mutations: {
        [constants.KEY_FEAURE_EXISTS](state, payload) {
            state.isKeyFeturesExits = payload;
        },
        [constants.WAIT_FOR_SPECIALS_API_DATA](state, payload) {
            state.isSpecialsloaded = payload;
        }
    },
};